import * as React from 'react';
import {useEffect, useRef, useState,useContext} from 'react';
import {
    Autocomplete,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Divider,
    Grow,
    ListSubheader,
    MenuItem,
    MenuList,
    Paper,
    Popper, TextField
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {getEnvName, LIVEOPS_ENV, PROD} from "./Utils/CommonUtils";
import {useLocation, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";

import {SnackBarContext} from "../core/context/snackBarProvider";

export default function SplitButton(props) {
    const {options, switchEnv, color, variant} = props;
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [searchParams] = useSearchParams();
    const sourceMode = useSelector((state) => state.data.SourceMode);

    const optionsKeys = Object.keys(options)
    const env1Name = getEnvName('env', sourceMode, searchParams);
    const env2Name = getEnvName('env2', sourceMode, searchParams);
    const [selectedIndex, setSelectedIndex] = useState(optionsKeys.indexOf(env1Name) === -1 || env2Name === PROD ?
        LIVEOPS_ENV : env1Name);
    //
    // console.log('selectedIndex', selectedIndex)
    // console.log('env1Name', env1Name)
    // console.log('env2Name', env2Name)
    const location = useLocation()


    const useSnackBars = () => useContext(SnackBarContext);
    const {addAlert} = useSnackBars();

    useEffect(() => {
        const env1Name = getEnvName('env', sourceMode, searchParams);
        const env2Name = getEnvName('env2', sourceMode, searchParams);
        setSelectedIndex(optionsKeys.indexOf(env1Name) === -1 || env2Name === PROD ? LIVEOPS_ENV : env1Name)
    }, [sourceMode, searchParams])



    const canSwitchValidation = () => {

        if(window.location.pathname.indexOf("/creator")>=0) {
            //let h = window.location.hash.split('#')
            //if(parseInt(h[1])>=1) {
                addAlert({text: 'You can\'t change environment while creating campaign', type: 'warning'})
                return false;
            //}
        }
        return true;
    }

    const handleClick = () => {
        if(!canSwitchValidation()) return false;
        switchEnv(selectedIndex);
    };

    const handleMenuItemClick = (event, index) => {
        if(!canSwitchValidation()) return false;

        setSelectedIndex(index);
        switchEnv(index)
        setOpen(false);
    };

    const handleToggle = () => {
        if(!canSwitchValidation()) return false;

        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const sortByName = (a, b) => {
        return a[1].name.localeCompare(b[1].name);
    }

    const sortedOptions = React.useMemo(() => {
        return Object.entries(options).sort((a, b) => {
            if (a[1].reserved && !b[1].reserved) return -1;
            if (!a[1].reserved && b[1].reserved) return 1;
            // для "Reserved" сортируем по приоритету, дальше по имени
            const byPriority = (b[1].reservedPriority || 0) - (a[1].reservedPriority || 0);
            if (byPriority !== 0) return byPriority;
            return (a[1].name || '').localeCompare(b[1].name || '');
        });
    }, [options]);


    return (
        <React.Fragment>
            <ButtonGroup
                ref={anchorRef} aria-label="split button">
                <Button variant={variant}
                        color={color}
                        onClick={handleClick}>

                    {selectedIndex}</Button>
                <Button
                    variant={variant}
                    color={color}
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <ArrowDropDownIcon/>
                </Button>
            </ButtonGroup>
            <Popper
                sx={{ zIndex: 1500 }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal

            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper sx={{ p: 0, minWidth: 260 }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <div>
                                    <Autocomplete
                                        id="env-select-autocomplete"
                                        size="small"
                                        autoHighlight
                                        openOnFocus
                                        options={sortedOptions}
                                        groupBy={(option) => (option[1].reserved ? 'Reserved' : 'Custom')}
                                        getOptionLabel={(option) => option[0]}
                                        value={sortedOptions.find(item => item[0] === selectedIndex) || null}
                                        onChange={(event, value) => {
                                            if (!canSwitchValidation()) return;
                                            if (value) {
                                                setSelectedIndex(value[0]);
                                                switchEnv(value[0]);
                                                setOpen(false);
                                            }
                                        }}
                                        renderGroup={(params) => (
                                            <li key={params.key}>
                                                <ListSubheader>{params.group}</ListSubheader>
                                                {params.children}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                autoFocus
                                                label=""
                                                placeholder="Search environment..."
                                            />
                                        )}
                                        // важно: рендерим список в том же дереве, чтобы исключить рассинхрон позиционирования
                                        disablePortal
                                        // небольшой отступ списка и стабильное вычисление позиций
                                        PopperProps={{
                                            placement: 'bottom-start',
                                            container: anchorRef.current,
                                            modifiers: [
                                                { name: 'offset', options: { offset: [0, 8] } },
                                                { name: 'flip', options: { altBoundary: true } },
                                                { name: 'preventOverflow', options: { boundary: 'window', padding: 8, altBoundary: true } },
                                                { name: 'computeStyles', options: { adaptive: false } },
                                            ],
                                            style: { minWidth: '400px' }
                                        }}
                                        componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                        ListboxProps={{ style: { maxHeight: 320 } }}
                                        disableClearable

                                    />
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

        </React.Fragment>
    );
}